export default "__VITE_ASSET__Bn1dwyxv__"